import { Col, Container, Image, Row } from "react-bootstrap";
import saurav from '../resources/saurav.jpeg'
import habib from '../resources/habib.jpeg'
import rahul from '../resources/rahul.jpeg'
import charles from '../resources/charles.jpeg'

const Team = () => {
    return (
        <Container>
            <h2 id="team" className="text-center" style={{marginTop: '1em', marginBottom: '1em'}}>Team</h2>
            <Row>
                <Col>
                    <h3 className="text-center">Behavior</h3>
                    <ul> 
                        <li>Every team member is to be treated with respect</li>
                        <li>Every team member is to communicate actions before taking them</li>
                        <li>Every team member will bring their ideas to the table and consider all possibilities</li>
                        <li>Every team member shall push each other to try harder</li>
                    </ul>
                </Col>
                <Col>
                    <h3 className="text-center">Coding Style</h3>
                    <ul>
                        <li>All JavaScript code will be written according to the Google JavaScript Style Guide</li>
                        <li>Every team member will be sure to follow this convention</li>
                    </ul>
                </Col>
                <Col>
                    <h3 className="text-center">Collaboration</h3>
                    <ul>
                        <li>A trunk-based development approach will be followed</li>
                        <li>Pull Requests are required for all features</li>
                        <li>Team members are encouraged to push their code often and PR when required</li>
                    </ul>
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col className="justify-content-md-center">
                    <Image className="d-block mx-auto img-fluid w-50" src= {saurav} width="50%" roundedCircle />
                    <h3 style={{marginTop: '1em'}} className="text-center">Saurav Bahali</h3>
                    <div className="text-center"><a className="bi bi-envelope-open-fill" href="mailto:sbahali@live.unc.edu"> Email</a></div>
                    <p className="text-center"><em>Back End Lead</em></p>
                    <p className="text-cneter">CS + Econ Major at UNC. Have interned at Fidelity and Microsoft.</p>
                </Col>
                <Col className="justify-content-md-center">
                    <Image className="d-block mx-auto img-fluid w-50" src= {charles} width="50%" roundedCircle />
                    <h3 style={{marginTop: '1em'}} className="text-center">Charles Chow</h3>
                    <div className="text-center"><a className="bi bi-envelope-open-fill" href="mailto:cchow@live.unc.edu"> Email</a></div>
                    <p className="text-center"><em>Webmaster</em></p>
                    <p className="text-center">Computer Science Undergrad (Senior) at the University of North Carolina at Chapel Hill. Has done previous SWE internships at SAS, Cisco, Nike, Amazon and Uber</p>
                </Col>
                <Col className="justify-content-md-center">
                    <Image className="d-block mx-auto img-fluid w-50" src= {habib} width="50%" roundedCircle />
                    <h3 style={{marginTop: '1em'}} className="text-center">Habib Khadri</h3>
                    <div className="text-center"><a className="bi bi-envelope-open-fill" href="mailto:hkhadri@email.unc.edu"> Email</a></div>
                    <p className="text-center"><em>Project Manager</em></p>
                    <p className="text-center">Studying CS, Business Administration, and Data Science at UNC Chapel Hill. Held previous internships at CCC Information Services and Metlife Inc.</p>
                </Col>
                <Col className="justify-content-md-center">
                    <Image className="d-block mx-auto img-fluid w-50" src= {rahul} width="50%" roundedCircle />
                    <h3 style={{marginTop: '1em'}} className="text-center">Rahul Narvekar</h3>
                    <div className="text-center"><a className="bi bi-envelope-open-fill" href="mailto:rnarveka@live.unc.edu"> Email</a></div>
                    <p className="text-center"><em>Front End Lead</em></p>
                    <p className="text-center">Computer Science and Economics Senior at UNC. Has held fullstack development positions at Fidelity and Bank of America. Also a big UNC basketball fan!</p>
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <h3 className="text-center"><a href="mailto:rnarveka@live.unc.edu,hkhadri@email.unc.edu,cchow@live.unc.edu,sbahali@live.unc.edu">Email Us</a></h3>
            </Row>
        </Container>
    )
}
export default Team;